import { Game } from './game.js';

// Initialize the game when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    console.log('🏟️ Grassline Snake Game - Paint Marker Edition 🏟️');
    console.log('Initializing game...');
    
    try {
        // Create game instance
        const game = new Game();
        
        // Make game globally accessible for debugging
        window.game = game;
        
        console.log('✅ Game initialized successfully!');
        console.log('🎮 Use arrow keys or WASD to control the snake');
        console.log('📱 Swipe on mobile devices for touch controls');
        
    } catch (error) {
        console.error('❌ Failed to initialize game:', error);
        
        // Show error message to user
        const errorDiv = document.createElement('div');
        errorDiv.style.cssText = `
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #F44336;
            color: white;
            padding: 20px;
            border-radius: 10px;
            text-align: center;
            font-family: Arial, sans-serif;
            z-index: 10000;
            max-width: 400px;
        `;
        errorDiv.innerHTML = `
            <h2>🚨 Game Error</h2>
            <p>Failed to load the game. Please refresh the page and try again.</p>
            <p><small>Error: ${error.message}</small></p>
            <button onclick="location.reload()" style="
                background: white;
                color: #F44336;
                border: none;
                padding: 10px 20px;
                border-radius: 5px;
                cursor: pointer;
                margin-top: 10px;
            ">Reload Game</button>
        `;
        document.body.appendChild(errorDiv);
    }
});

// Handle page visibility changes (pause game when tab is hidden)
document.addEventListener('visibilitychange', () => {
    if (window.game && window.game.getGameState() === 'playing') {
        if (document.hidden) {
            window.game.pauseGame();
        }
    }
});

// Handle window resize
window.addEventListener('resize', () => {
    if (window.game) {
        window.game.updateCanvasSize();
    }
});

// Prevent zoom on double-tap for mobile
let lastTouchEnd = 0;
document.addEventListener('touchend', (e) => {
    const now = Date.now();
    if (now - lastTouchEnd <= 300) {
        e.preventDefault();
    }
    lastTouchEnd = now;
}, { passive: false });

// Prevent context menu on long press
document.addEventListener('contextmenu', (e) => {
    if (e.target.tagName === 'CANVAS') {
        e.preventDefault();
    }
});

// Service Worker registration for offline support (optional)
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
            .then((registration) => {
                console.log('SW registered: ', registration);
            })
            .catch((registrationError) => {
                console.log('SW registration failed: ', registrationError);
            });
    });
}

// Performance monitoring
if (typeof performance !== 'undefined' && performance.mark) {
    performance.mark('game-start');
    
    window.addEventListener('load', () => {
        performance.mark('game-loaded');
        performance.measure('game-load-time', 'game-start', 'game-loaded');
        
        const measures = performance.getEntriesByType('measure');
        const loadTime = measures.find(m => m.name === 'game-load-time');
        if (loadTime) {
            console.log(`🚀 Game loaded in ${loadTime.duration.toFixed(2)}ms`);
        }
    });
}

// Debug mode toggle (for development)
if (window.location.search.includes('debug=true')) {
    console.log('🐛 Debug mode enabled');
    
    // Add debug panel
    const debugPanel = document.createElement('div');
    debugPanel.id = 'debug-panel';
    debugPanel.style.cssText = `
        position: fixed;
        top: 10px;
        right: 10px;
        background: rgba(0, 0, 0, 0.8);
        color: white;
        padding: 10px;
        border-radius: 5px;
        font-family: monospace;
        font-size: 12px;
        z-index: 1000;
        display: none;
    `;
    document.body.appendChild(debugPanel);
    
    // Debug key handler
    document.addEventListener('keydown', (e) => {
        if (e.code === 'F12' || (e.ctrlKey && e.shiftKey && e.code === 'KeyI')) {
            e.preventDefault();
            const panel = document.getElementById('debug-panel');
            panel.style.display = panel.style.display === 'none' ? 'block' : 'none';
            
            if (panel.style.display === 'block' && window.game) {
                updateDebugInfo();
                setInterval(updateDebugInfo, 1000);
            }
        }
    });
    
    function updateDebugInfo() {
        const panel = document.getElementById('debug-panel');
        if (!panel || !window.game) return;
        
        const state = window.game.getGameState();
        const score = window.game.getScore();
        const grid = window.game.getGridDimensions();
        
        panel.innerHTML = `
            <div>State: ${state}</div>
            <div>Score: ${score}</div>
            <div>Grid: ${grid.width}x${grid.height}</div>
            <div>FPS: ${Math.round(1000 / (performance.now() - (window.lastFrameTime || 0)))}</div>
        `;
        
        window.lastFrameTime = performance.now();
    }
}

// Analytics placeholder (can be replaced with real analytics)
const analytics = {
    track: (event, data = {}) => {
        console.log(`📊 Analytics: ${event}`, data);
        // Here you would send data to your analytics service
    }
};

// Track game events
window.addEventListener('load', () => {
    analytics.track('game_loaded', {
        userAgent: navigator.userAgent,
        screen: `${screen.width}x${screen.height}`,
        timestamp: new Date().toISOString()
    });
});

// Export for external use
export { Game };
